import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pl-1 pr-2 py-2 bg-racq-blue justify-start items-center gap-0.5 inline-flex rounded-t-sm"
}
const _hoisted_2 = { class: "text-xs-bold text-racq-true-white uppercase" }
const _hoisted_3 = {
  key: 1,
  class: "pl-4 pr-8 pb-2 text-left"
}

import { ref } from 'vue';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import { ImageField } from '@sitecore-jss/sitecore-jss-vue/types/components/Image';
import ShowHideButton from '@/components/ShowHideButton/ShowHideButton.vue';
import RadioCardListItem from './RadioCardListItem.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'RadioCardListMegaItem',
  props: {
    label: {},
    help: {},
    image: {},
    isSelected: { type: Boolean },
    disabled: { type: Boolean },
    rightLabel: {},
    rightHelp: {},
    hideCheckbox: { type: Boolean },
    callOut: {},
    visibleBody: {},
    hiddenBody: {}
  },
  setup(__props: any) {



const showMore = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.callOut)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "bg-icon-star icon w-4 h-4 bg-no-repeat bg-contain" }, null, -1)),
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.callOut), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(RadioCardListItem, {
      label: _ctx.label,
      help: _ctx.help,
      image: _ctx.image,
      isSelected: _ctx.isSelected,
      rightLabel: _ctx.rightLabel,
      rightHelp: _ctx.rightHelp,
      hideCheckbox: _ctx.hideCheckbox,
      isMega: !!_ctx.visibleBody
    }, null, 8, ["label", "help", "image", "isSelected", "rightLabel", "rightHelp", "hideCheckbox", "isMega"]),
    (_ctx.visibleBody)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_unref(RichText), {
            field: { value: _ctx.visibleBody },
            class: "text-racq-med-grey text-base richtext"
          }, null, 8, ["field"]),
          (showMore.value)
            ? (_openBlock(), _createBlock(_unref(RichText), {
                key: 0,
                field: { value: _ctx.hiddenBody },
                class: "text-racq-med-grey text-base richtext"
              }, null, 8, ["field"]))
            : _createCommentVNode("", true),
          (_ctx.hiddenBody)
            ? (_openBlock(), _createBlock(ShowHideButton, {
                key: 1,
                showMore: showMore.value,
                disabled: _ctx.disabled,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showMore.value = !showMore.value))
              }, null, 8, ["showMore", "disabled"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})